/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';

export interface TiltArrowIconProps {
  color?: string;
  size?: number;
}
/*
 * Defines the Design Language System (DLS) Tilt Arrow Icon component.
 */
export const TiltArrowIcon = ({size = 10, color = dlsColor('caRed')}: TiltArrowIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 26 23" fill={'none'}>
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M17.0846 0.292893C17.4751 -0.0976311 18.1083 -0.097631 18.4988 0.292893L24.9571 6.75123C25.3476 7.14175 25.3476 7.77492 24.9571 8.16544L18.4988 14.6238C18.1083 15.0143 17.4751 15.0143 17.0846 14.6238C16.694 14.2332 16.694 13.6001 17.0846 13.2096L22.8358 7.45833L17.0846 1.70711C16.694 1.31658 16.694 0.683417 17.0846 0.292893Z" fill={color}/>
      <path xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" d="M0 20.375C0 12.6888 6.23051 6.45833 13.9167 6.45833H24.25C24.8023 6.45833 25.25 6.90605 25.25 7.45833C25.25 8.01062 24.8023 8.45833 24.25 8.45833H13.9167C7.33508 8.45833 2 13.7934 2 20.375V21.6667C2 22.219 1.55228 22.6667 1 22.6667C0.447715 22.6667 0 22.219 0 21.6667V20.375Z" fill={color}/>
    </svg>
  );
};
